module.exports = __webpack_public_path__ + "static/media/logo-cirris.815cc768.png";